/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-limit.reducer';

export const PharmacyLimitDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyLimitEntity = useAppSelector(state => state.pharmacyLimit.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyLimitDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyLimit.detail.title">PharmacyLimit</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.id}</dd>
          <dt>
            <span id="lowerLimit">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.lowerLimit">Lower Limit</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.lowerLimit}</dd>
          <dt>
            <span id="fmDays">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.fmDays">Fm Days</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.fmDays}</dd>
          <dt>
            <span id="fmPercent">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.fmPercent">Fm Percent</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.fmPercent}</dd>
          <dt>
            <span id="smDays">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.smDays">Sm Days</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.smDays}</dd>
          <dt>
            <span id="smPercent">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.smPercent">Sm Percent</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.smPercent}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.timestampEntry}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.addedById">Added By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.modifiedById">Modified By Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.addedByType">Added By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.pharmacyLimit.modifiedByType">Modified By Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyLimitEntity.modifiedByType}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyLimit.drug">Drug</Translate>
          </dt>
          <dd>{pharmacyLimitEntity.drug ? pharmacyLimitEntity.drug.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyLimit.consumable">Consumable</Translate>
          </dt>
          <dd>{pharmacyLimitEntity.consumable ? pharmacyLimitEntity.consumable.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyLimit.implant">Implant</Translate>
          </dt>
          <dd>{pharmacyLimitEntity.implant ? pharmacyLimitEntity.implant.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyLimit.pharmacy">Pharmacy</Translate>
          </dt>
          <dd>{pharmacyLimitEntity.pharmacy ? pharmacyLimitEntity.pharmacy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-limit" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-limit/${pharmacyLimitEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyLimitDetail;
